import * as React from "react"

const SvgComponent = (props) => (
  <svg
    width={14}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.37.143C7.325.097 7.279.05 7.233.05 7.139.004 7.092.004 7 .004c-.371 0-.65.232-.696.603v7.092c.047.186.14.371.278.464.047.046.093.046.186.046.093.047.139.047.232.047.37 0 .649-.278.695-.65V.7c0-.231-.093-.463-.324-.556Zm2.828 1.344c-.046-.046-.092-.092-.139-.092-.092-.047-.185-.047-.231-.047-.371 0-.65.232-.742.603v.232a.85.85 0 0 0 .324.463c.047 0 .093.047.186.047 1.761.973 3.013 2.827 3.013 5.006 0 3.06-2.55 5.563-5.609 5.563-3.06 0-5.61-2.503-5.61-5.563a5.638 5.638 0 0 1 3.06-5.006c.047 0 .093 0 .093-.047.185-.092.325-.324.37-.51v-.139a.75.75 0 0 0-.74-.649h-.14c-.093.047-.232.14-.325.186C1.483 2.693 0 5.057 0 7.699c0 3.848 3.152 7 7 7s7-3.152 7-7a6.974 6.974 0 0 0-3.801-6.212Z"
      fill="#636F7C"
    />
  </svg>
)

export default SvgComponent
